
import { redirect, RouteObject } from "react-router";
import {
  GetPodborkaByUrlAPI
} from "./entities/service/model/products.api";
import Order from './pages/account/order';
import Account from './pages/account/profile';
import Login from './pages/auth/LoginPage';
import Blog from './pages/blog';
import Info from './pages/info';
import Main from './pages/mainPage';
import NewUsluga from './pages/new_usluga';
import NotFound from './pages/not_found';
import Podborka from './pages/podborka';
import TestPageRoute from './pages/TestPageRoute';
import Usluga from './pages/usluga';
import Uslugi from './pages/uslugi';
import { Layout } from './shared/layouts/Layout';

// Без ProtectedRoute
const routes_all: RouteObject[] = [
  {
    path: "/", element: (
      <Layout>
        <Main />
      </Layout>
    )
  },
  {
    path: "/uslugi/", element: (
      <Layout>
        <Uslugi />
      </Layout>
    ),
  },
  {
    path: "/uslugi/:url/",
    element: (
      <Layout>
        <TestPageRoute children_a={<Usluga />} children_b={<NewUsluga />} />
      </Layout>
    ),
  },
  {
    path: "/uslugi/reviews-avito/",
    loader: () => {
      return redirect("/uslugi/reviews-doski-obyavlenij/", {
        status: 301
      });
    },
  },
  {
    path: "/blog/", element: (
      <Layout>
        <Blog />
      </Layout>
    )
  },
  {
    path: "/blog/:url/", element: (
      <Layout>
        <Info />
      </Layout>
    )
  },
  {
    path: "/account/", element: (
      <Layout>
        <Account />
      </Layout>
    )
  }, // SSR не знает isAuth
  {
    path: "/account/order/:order_id/", element: (
      <Layout>
        <Order />
      </Layout>
    )
  },
  {
    path: "/account/login/", element: (
      <Layout>
        <Login />
      </Layout>
    )
  },
  {
    path: "/podborki/",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
  {
    path: "/podborki/:url/",
    element: (
      <Layout>
        <Podborka />
      </Layout>
    ),
    loader: async ({ params }) => {
      if (!params.url) throw new Error("URL is required");
      return await GetPodborkaByUrlAPI({ podborka_url: params.url });
    },
  },
  { path: "*", element: <Main /> }, // SSR не использует Navigate
];

export default routes_all;
